import { IDemandasServiceMock } from "@/services/saldosonline/demandas/demandas.types";

export const mockDemandasService = (): IDemandasServiceMock => ({
  saveUpdateDemanda: jest.fn(),
  cancelDemanda: jest.fn(),
  demandasCompatibles: jest.fn(),
});
